export default __webpack_public_path__ + "static/media/windows.d6c01210.png";